module.exports = __webpack_public_path__ + "img/pratiche-prjweb.9a4aa050.png";